export default __webpack_public_path__ + "static/media/revenueEarnings.c7e53a80.png";